import React from 'react'
import { connect } from 'react-redux'

const isActive = (direction, standings) => {
  switch(direction) {
    case "NEXT_WEEK":
      return standings.activeTribalNumber < standings.totalTribalsCount ? true : false
    case "LAST_WEEK":
      return standings.activeTribalNumber > 0 ? true : false
    case "FINAL_WEEK":
     return standings.activeTribalNumber < standings.totalTribalsCount - 1 ? true : false
   case "FIRST_WEEK":
     return standings.activeTribalNumber > 1 ? true : false
    default:
      throw new Error('Unknown direction: ' + direction)
      
  }
}

let ChangeWeek = ({ dispatch, actionType, children, standings }) => {
  if(isActive(actionType, standings)) {
    return (
      <button onClick={()=>( isActive(actionType, standings) ? dispatch({type: actionType}) : () => {return} )}
        className={"mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-color--teal"}>
        {children}
      </button>
    )
  }
  else {
    return (
      <button onClick={()=>( isActive(actionType, standings) ? dispatch({type: actionType}) : () => {return} )}
        className={"mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-color--"} disabled>
        {children}
      </button>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  standings: state.standings
})

ChangeWeek = connect(
  mapStateToProps
)(ChangeWeek)

export default ChangeWeek
